export default {

  login: {
    loginTitle: 'Login',
    emailInfo:
      'If you want to get commission for uploaded photos, please enter the email address associated with your paypal account',
    email: 'Email',
    phoneNumberInfo:
      'If you want to payout money, please enter correct phone number',
    phoneNumber: 'Phone number',
    password: 'Password',
    repassword: 'Repeat password',
    forgotPassword: 'Do not you remember the password?',
    loginButton: 'Sign in',
    loginNotify: 'Logged in!',
    register: 'Registration',
    username: 'User name',
    registration: 'Register',
    createAccount: 'Create an account',
    referal: 'Add referal',
    referalTitle: 'Add a referring runner',
    referalDesc:
      "(optional) You can enter the STARTING number of your friends runner - for every 50 pictures uploaded by the number's friends, they get a 5% discount!",
    runnerNumber: 'Runner number',
    accountType: 'Account type',
    supporter: 'Amateur photographer/bystander',
    photographer: 'Professional photographer (hired)',
    portfolioTitle:
      'I am a professional photographer, I want to receive payment for my photos. I am applying for verification - Link to my portfolio:',
    portfolio: 'Portfolio',
  },
  recoverPassword: {
    recoverDescription:
      'Please input an email used when registering account, we will send you a link to recover your password',
    recoverButton: 'Recover password',
    recoverGoBack: 'Hide password recovery',
    recoverSuccess:
      'If the email address you provided is associated with an account in our system, we\'ve sent you an email with instructions on how to reset your password. If you don\'t receive the email within a few minutes, please check your SPAM folder or try again.',
    recoverError: 'An error occured while sending a recovery mail',
    title: 'Set a new password',
    resetButton: 'Change password',
    repeat: 'Repeat password',
    resetInfo: 'Password strength requirements:',
    requirements1: 'min 8 characters',
    requirements2: 'min 1 uppercase',
    requirements3: 'min 1 lowercase',
    requirements4: 'min 1 number',
    resetSuccess: 'Password changed! You may now login.',
    invalidEmail: 'Incorrect email',
    invalidKey: 'Password reset key has expired, please request a new reset email.',
    validation: 'Password strength requirements not met.',
  },
  validation: {
    required: 'The field is required',
    minValue: 'The minimum number of characters is 3',
    email: 'Please enter a valid email',
    countryRequired: 'Select a country',
    phoneNumber: 'Please enter a valid phone number',
    samePassword: 'Passwords should be identical',
    completeAllFields: 'Complete all data',
    accountType: 'Account type is invalid',
    portfolio: 'Portfolio url is invalid',
    minPrice: "Price must be at least {min} zł",
    postcode: 'Invalid postcode format, must be 1-6 characters',
    language: 'Language must be selected',
    bankAccountIban:
      'IBAN must be between 15-34 characters and of valid format',
    bankAccountCurrency: 'Your bank account currency must be selected',
    invalidFormat: 'Wrong format letters, numbers and special characters "." and "_" allowed'
  },
  duplicates: {
    general:
      'Your recent photos that you uploaded are duplicates of photos that already exist in the system. The following events contain duplicates:',
    unknownEvent: 'Unknown run',
    acceptSuccess: 'Duplicates have been removed',
    acceptError: 'An error occurred while removing duplicates',
  },
  navigation: {
    home: 'Home',
    addPhoto: 'Add photo',
    addVideo: 'Add video',
    walletProfile: 'Wallet',
    myEvents: 'My events',
    bookings: 'Bookings',
    logout: 'Sign out',
    profile: 'Your profile',
    signAs: 'Signed in as',
    signIn: 'Sign in',
    role: 'Role',
  },
  events: {
    eventsDescription:
      "Events you are part of are displayed below, click on the button to go to individual event's dashboard",
    eventStart: 'Event date',
    eventsDescription2: "After filling out the add event form, the event will be sent for admin verification. Once successfully verified, it will appear in the 'Verified' tab.",
    albumsQty: 'Albums',
    button: 'Go to dashboard',
    loading: 'Loading your events...',
    noEventsMessage: 'You are not part of any events.',
    noOtherEvents: 'No other events',
    eventStatus: 'Event status',
    verified: 'Verified',
    unverified: 'Unverified',
    addEvent: 'Add event',
    editEvent: 'Edit event information',
    deleteBtn: 'Delete event',
    deleted: 'Event draft deleted',
    sponsorPhoto: {
      description: 'Global Sponsor Photo Settings. This will be used for sponsor photo overlays in races where you are assigned as a sponsor.',
      info: 'You can also change the sponsor photo for the selected race only by pressing the edit button in the race below.',
      eventImageField: 'Event sponsor image (max. 5mb)',
      globalImageField: 'Global sponsor image (max. 5mb)',
      modalInfo: 'Change the sponsor photo for this event, it will be used to overlay sponsor photos in the event.',
      modalWarning: 'Changes are only possible before the event starts.',
      formError: 'An error occurred while updating the sponsor photo.',
      formSuccess: 'Sponsor photo successfully updated.',
      eventSponsorPhotoInfo: 'Add unique Sponsor watermark to photos in this event',
      noGlobalImage: 'No default sponsor image uploaded yet',
    },
    sponsorAssets: {
      title: 'Sponsor Assets',
      description: 'Manage your sponsor assets for this event. Here you can upload files related to your sponsorship.',
      uploadLabel: 'Select file',
      assetName: 'File name (max 18 chars)',
      uploadRestrictedDate: 'Uploading files is possible only until the event start date.',
      duplicate: 'This file has already been added',
      noAssets: 'No assets added yet.',
      button: 'Assets'
    },
    form: {
      eventTitle: 'Event name',
      photoPrice: 'Single photo price (PLN)',
      albumPrice: 'Album price (PLN)',
      image: 'Event page image (max. 5mb)',
      submit: 'Submit for verification',
      authorsCommission: 'Professional photo author\'s commission (%)',
      hasBib: 'There will be a bib number',
      hasBibDescription: "By checking the box above, I confirm that the participants have race numbers (on their shirts, on a placard attached to their clothing, etc.).",
      faceRecognitionInfo: "(Facial recognition functionality is temporarily disabled due to legal regulations, current European regulations do not permit its availability.)",
      error: 'Error while submitting a form, please check all fields.',
      success: 'Event successfully created!',
      fileFormat: 'Wrong file format. jpeg, jpg, png formats are allowed.',
      fileSize: 'File size too big',
      upload: 'Error uploading this file, please choose another image.',
      update: 'Update event',
      updateSuccess: 'Event updated successfully!',
      fetchError: 'Error while getting event information, try again.'

    },
    error: {
      notFound: 'Event not found',
      update: 'Error while updating event. Please try again.',
      add: 'Error while adding event. Please try again.'
    },
    photographer: {
      myEvents: "Private Events",
      eventsDescription: "A list of your private events, accessible only through your portfolio page or via a direct link you may share.",
      eventsDescription3: "Fill out the form with correct information. After admin verification, it will not be possible to change the event details."
    },
    organizer: {

    },
    verifiedTab: 'Approved events',
    unverifiedTab: 'Awaiting approval',
    eventSettings: 'Events Settings',
    noActiveEvents: 'No active events',
    goToAlbum: 'Go to album',
    goToLanding: 'Go to portfolio',
    location: 'Location',
    editTooltip: 'Edit',
    deleteTooltip: 'Delete',
    locationInVerification: 'In verification'
  },
  dashboard: {
    menu: {
      shares: 'Shares',
      totalOrders: 'Orders',
      backBtn: 'Back to events',
      stats: 'Statistics',
      addPhoto: 'Add photos',
      prefillForm: 'Form has been prefilled with event data',
      showMore: 'Show more',
      showLess: 'Hide',
      currencyBtn: 'Select a currency',
      currencyInfo: 'Showing data for currency'
    },
    main: {
      salesReport: 'Sales report',
      earnedCommision: 'Earned commission',
      comissionPayout: 'Available to withdraw',
      withdraw: 'Withdraw',
      albumViews: 'Album views',
      eventViews: 'Event views',
      albumPhotos: 'Photos in a event',
      photosSold: 'Purchased photos',
      startDate: 'Event date',
      totalOrders: 'Total orders',
      totalAlbumSalesAmount: 'Album sales',
      socialMediaSharesCount: 'Shares',
      totalCommissionEarned: 'Commission earned',
      totalCommissionPaid: 'Total withdrawn',
      amountToBePaid: 'Available to withdraw',
      totalAlbumViews: 'Total album views',
      totalPhotosInEvent: 'Total photos in event',
      totalAlbumsSold: 'Albums sold',
      totalPhotosSold: 'Single sold photos',
      loading: 'Loading event data...',
    },
    ordersTable: {
      title: 'Orders',
      orderId: 'Order ID',
      orderDate: 'Date',
      albumLink: 'Album Link',
      orderAmount: 'Amount',
      coupon: 'Coupon',
      currency: 'Currency',
      authorCommission: 'Author Commission',
      paygateCommission: 'Paygate Commission',
      afterFeesTotal: 'Organizer Profit',
      noOrders: 'No orders for this event.',
      sumCommissions: 'Total Organizer Commission',
    },
    sponsorAssetsTable: {
      title: 'Sponsor Assets Stats',
      totalDetections: 'Total Detections',
      totalEventPhotos: 'Total Event Photos',
      totalSponsoredPhotos: 'Photos with your brand',
      exposureRatio: 'Exposure Ratio',
      assetName: 'Asset Name',
      detectionsCount: 'Detections',
      image: 'Preview',
      noData: 'No detections yet',
    },
    sharesTable: {
      title: 'Shares table',
      shareId: 'ID',
      link: 'Link',
      copy: 'Copy',
      linkCopySuccess: 'Link copied to clipboard!',
      linkCopyFail: 'Failed to copy link',
      noData: 'No shared albums on record',
      product: 'Product'
    },
    albumViewsTable: {
      title: 'Album views table',
      noData: 'No albums available',
      albumNumber: 'Runner/Album Number',
      views: 'Album views',
      filterAlbums: 'Search views for album number'
    },
    charts: {
      day: 'Last 24 hours',
      week: 'Last 7 days',
      month: 'Last 30 days',
      total: 'Total',
      timeFrame: 'Time period',
      weekLabel: 'Week'
    }
  },
  role: {
    photographer: 'Photographer',
    supporter: 'Supporter',
    organizer: 'Organizer',
    sponsor: 'Sponsor',
    photographer_verification: 'Photographer (verification)',
    agent: 'Agent',
  },
  addMedia: {
    addPhotoTitle: 'Add photos',
    addVideoTitle: 'Add videos',
    addFiles: 'Select files',
    blockedText: 'To add photos log in',
    subHeaderTitle: 'RunPixie - Find Yourself!',
    resume: {
      detectedMessage: 'An unfinished upload was found: {confirmed} of {total} photos are already confirmed.',
      reselectMessage: 'To resume, select the same files or folder again. {remaining} of {total} photos remain.',
      resume: 'Resume upload',
      resumeSelected: 'Resume with selected files',
      resumeSelectedPrimary: 'Resume upload ({count})',
      selectRemainingPrimary: 'Select remaining photos ({count})',
      selectedReadyMessage: '{remaining} of {total} photos still need to be sent. They are already selected below — you can resume right away.',
      discard: 'Discard saved session',
      chooseFolder: 'Choose folder (resumable)',
      reselectInstruction: 'Select the same files or folder again, then click “Resume with selected files”. Already confirmed photos will be skipped.',
      filesMismatch: 'Matched {matched} of {required} remaining files. Select the complete set of remaining photos.',
      noSupportedFiles: 'No supported photos were found in the selected folder.',
      folderError: 'The selected folder could not be read.',
    },
    guide: {
      title: 'Safe photo uploading',
      intro: 'Large uploads can be safely paused, resumed, or finished later.',
      tabs: {
        how: 'How it works',
        faq: 'What if…?',
      },
      resumeAfterRefresh: 'If you accidentally refresh or close the page, we will help you resume after you return instead of starting from the beginning.',
      pause: '“Pause” stops new uploads from starting. Batches already in progress may still finish safely.',
      resumeLater: '“Resume later” saves your progress and leaves only photos that have not yet been confirmed by the system.',
      autoRetry: 'If there is a temporary network or server problem, the uploader retries automatically.',
      keepFiles: 'Do not delete or move the photos on your computer until the whole upload is complete.',
      gotIt: 'Got it',
      open: 'How does safe uploading work?',
      largeUploadNotice: '{count} photos selected. Large uploads can run without watching every file; progress is saved and can be resumed.',
      pausedNotice: 'Upload paused. Batches already in progress may still finish safely.',
      continuedNotice: 'Upload resumed.',
      savedLaterNotice: 'Progress saved. {confirmed} of {total} photos are confirmed; {remaining} remain. You can continue later.',
      resumedNotice: 'Resuming the saved upload. {confirmed} photos are already confirmed and {remaining} remain.',
      faq: {
        offlineQuestion: 'What if I lose my internet connection?',
        offlineAnswer: 'Uploading will wait for the connection and try to continue when it returns. You do not need to restart the whole set manually.',
        closedQuestion: 'What if I close or refresh the page?',
        closedAnswer: 'When you return, we will show the unfinished session. If needed, select the same files or folder again; photos already saved successfully will be skipped.',
        failedQuestion: 'What if only a few photos fail?',
        failedAnswer: 'Successfully uploaded photos stay saved. We will show exactly how many files failed and let you retry only those files.',
        laterQuestion: 'What does “Resume later” do?',
        laterAnswer: 'It saves the current progress and leaves only photos not yet confirmed by the server to be sent when you return.',
      },
    },
    upload: {
      confirmedPhotos: 'Confirmed photos',
      transferredData: 'Transferred data',
      speed: 'Upload speed',
      activeBatches: 'Active batches',
      pendingPhotos: 'Pending',
      deferredPhotos: 'Deferred',
      problemPhotos: 'Problematic',
      partialFailure: 'Failed to upload {failed} of {total} photos. {sent} were uploaded successfully.',
      retryFailed: 'Retry ({count})',
      keepFailedForLater: 'Leave for later ({count})',
      actions: {
        pause: 'Pause',
        resume: 'Resume',
        resumeLater: 'Resume later',
      },
      status: {
        idle: 'Waiting to start upload…',
        preparing: 'Preparing photos for upload…',
        uploading: 'Uploading photos…',
        stalled: 'No transfer progress. The connection may be temporarily congested…',
        waiting: 'Data sent. Waiting for server confirmation…',
        waitingLong: 'The server is still processing the batch. Upload has not been interrupted…',
        retrying: 'Temporary problem detected. The upload will keep retrying automatically…',
        deferred: 'Some batches were deferred. The remaining photos are being uploaded first…',
        offline: 'No internet connection. Upload will resume automatically when the connection returns…',
        pausing: 'Pausing. Finishing the batches currently in progress…',
        paused: 'Upload paused.',
        stopping: 'Finishing active batches and saving the remaining photos for later…',
        failed: 'Some photos could not be uploaded.',
        completed: 'Upload completed.',
      },
    },
    agreement:
      'By uploading photos, you accept the Terms, conditions of use, returns and cancellations policy, licence agreement',
  },
  common: {
    clear: 'Clear',
    add: 'Add',
    subHeaderTitle: 'RunPixie - Find Yourself!',
    country: 'Country',
    completeData: 'Complete data',
    city: 'City',
    close: 'Close',
    submit: 'Submit',
    event: 'Event',
    summary: 'Summary',
    imagesCount: 'Selected images',
    videosCount: 'Selected videos',
    date: 'Date',
    next: 'Next',
    return: 'Back',
    ups: 'Something went wrong!',
    turnOnThumbs: 'Enable thumbnails in the preview',
    turnOnThumbsInfo:
      'Enable this option if you want to see thumbnails in the preview (not recommended when adding more photos)',
    statuteRoute: '/en/license-agreement/',
    checkHere: 'check here',
    understand: 'I understand',
    save: 'Save',
    edit: 'Edit',
    loadingEvents: 'Loading events',
    refetchEvents: 'Reload events',
    deleted: 'Deleted',
    added: 'Added successfully'
  },
  userPanel: {
    title: 'User panel',
    hello: 'Hello',
    addedPhoto: 'Added photos',
    inSystem: 'In system from',
    country: 'Country',
    city: 'City',
    gear: 'Event',
    emailChanges: 'Email was changed',
    badEmail: 'Please enter a valid email',
    walletRequestsTitle: 'Registered withdrawal requests',
    walletCommissionsTitle: 'Registered commissions',
    blockedMoneyInfo: 'Value of your current withdrawal requests (blocked)',
    noPersonalDataInfo:
      'To create withdrawal proposal, please fill your personal data: first name, last name, phone number and address',
    noWithdrawIntegration:
      'To create withdrawal proposal, Your account must be integrated with the payment partner',
    withdrawMoney: 'Dispose of funds',
    minWithdrawValue: 'Minimum Withdrawal Amount',
    withdraw: 'Withdraw',
    wallet: {
      title: 'Wallet',
      bookingTableTitle: 'Commissions for photographer bookings',
      bookingReference: 'Booking no. {bookingId}',
      tableColumns: {
        bookingId: 'Booking ID',
        bookingTitle: 'Reference',
        bookingPrice: 'Booking Price',
      }
    },
    ownCommisionsUnpaid: 'The sum of unpaid commissions',
    ownCommisionsAll: 'The sum of all commissions earned',
    albumName: 'Album name',
    commission: 'Commission',
    status: 'Status',
    sum: 'Sum',
    yourData: 'Your data',
    phoneNumber: 'Nr.',
    paymentInfo:
      'Data necessary to make withdrawals - if after the change, you can still see the old data, log out and log in again.',
    paid: 'Paid',
    tableWalletHint:
      'Below is a list of albums with your photos that someone has bought. Remember that the amount of the commission obtained is (a) the possible bonus for the best photo in the package and (b) the amount of the commission to be divided between the authors proportionally according to the number of photos.',
    tableWalletHintOther:
      'Below is a list of commissions earned for purchased albums and photographs. Each row relates to order in which commission was earned.',
    tableColumns: {
      album: 'Number of the album sold',
      gear: 'Event',
      commission: 'The amount of commission received',
      date: 'Data',
      commissionData: 'Date of the commission payout',
      name: 'Name',
    },
    tableTitle: 'Commissions earned',
    imagesTableTitle: 'List of your photos within the album',
    promptWalletInfo:
      'You pay a commission for the license granted to RunPixie for photos that have been purchased by runners, in accordance with the website regulations and the license agreement',
    promptWalletInfo2:
      'Recommended payment above PLN 20, required after exceeding PLN 500. The cost of the payment is PLN 2.5. Funds not disbursed within 2 years are forfeited',
    regulamin: 'terms and conditions of the website and the license agreement',
    accountData: 'Account details:',
    billingAddress: 'Billing address',
    userData: {
      name: 'First name',
      surname: 'Last name',
      nrTelephone: 'Phone',
      address: 'Address',
      address2: 'Address 2',
      state: 'State/Province',
      company: 'Company',
      country: 'Country',
      city: 'City',
      postcode: 'Postcode',
      email: 'Email',
      role: 'Role',
      submit: 'Update data',
    },
    empty: 'Not completed',
    completeData:
      'Complete data (you will be redirected to a new tab [you will need to log in again])',
    editData: 'Edit data',
    solded: 'Sold',
    withdrawNotConnectedInfo: 'No connection with the external withdraw platform',
    connectHereLabel: 'Connect here',
    billingDataUpdating: 'Updating...',
    registerPhotographer: "Register photographer",
    registerPhotographerTitle: "Use the form to register photographers collaborating with you.",
    accountVerificationTitle: "Account Verification",
    accountVerificationInfo: "We will verify their details, create an account for them, and notify them by email about the need to generate a password to access the app.",
    shareConsentTitle: "Consent to Share",
    shareConsentInfo: "Make sure you have their permission to share their data. If they raise an objection, we will be forced to delete their account and contact you.",
    integration: {
      title: 'Withdrawal integration',
      bankAccountIban: 'Bank account IBAN',
      bankAccountCurrency: 'Bank account currency',
      language: 'Language',
      submit: 'Create/Sync Useme account',
      taxId: 'Tax Id',
      userExists:
        'Found account matching provided details on Useme. Integration successful. Please login again.',
      integrationValidation:
        'Account validation error, make sure fields Tax Id and IBAN are correct. If you already have Useme account, all details need to match your Useme profile.',
      editInformation:
        'If you would like to edit any of the details in future, you can do it via https://useme.com official site',
      informationTitle: 'Information regarding Useme integration',
      description:
        'In order to earn money for your photographs, you need to have Useme account. Useme is a third-party payments provider, that makes it easy for us to pay you, and for you to receive the payments. Registration is free and easy.',
      registerWays: 'You can register with Useme in 2 ways:',
      recommendedOption: 'Recommended option',
      optionTwo:
        'If you choose to register via official Useme site, you need to come back and use the same details in our form to complete the integration. Please note the details need to be identical to the ones on your Useme profile.',
      optionOne:
        'If you decide to register via our form, after successful registration, you can obtain your initial password by sending a reset password link ',
      optionOneAdditional:
        'You can then use this password to login to your Useme account and change the details as you like.',
      important: 'Important',
      termsAcceptance:
        'By registering with Useme, you accept their Terms & Conditions.',
      moreInfo: 'For more information visit',
      successTitle: 'Useme withdrawals integration completed!',
      successMessage: 'You have successfully integrated your Useme account.',
      emailLabel: 'Useme account email:',
      approvalMessage:
        'Once our staff approves you as a professional photographer, you will be ready to start earning money for your photos.',
      payoutDetails:
        'Please remember if you would like to change any of your payout details, you can do so via Useme portal available after logging in on their ',
      resetPasswordMessage:
        'If during integration, we have created an account for you on Useme, you can login to their portal and reset password',
      resetPasswordLink: 'here.',
      officialSite: 'official site',
    },
    settings: {
      title: 'Photographer\'s settings',
      photoSalesTitle: 'Global photo sales settings',
      disableBulkSale: 'Disable bulk sale of my photos',
      bulkSaleDescription: 'In this section, you set your global bulk sale preferences. These apply as the default settings for newly uploaded photos. If a specific event does not have defined settings at the time of uploading photos, we will assign these global settings to it.',
      description: 'In this section, you can choose specific events for which you want to disable bulk sales and enable individual photo sales. Upon uploading the first photo to an event, if it had no settings, your global settings will be automatically applied.',
      settingsLocked: 'Settings locked',
      settingsLockedInfo: 'Bulk sales can only be disabled before uploading the first photo to the event (when global bulk sale is enabled). Once you have uploaded photos, you cannot disable bulk sales, but you have a one-time option to restore it. If bulk sales are disabled, you can change the single photo price multiple times regardless of the event date.',
      bulkSaleDisabled: 'Bulk sale: Disabled',
      bulkSaleEnabled: 'Bulk sale: Enabled',
      singlePhotoPrice: 'Single photo price in zł',
      singlePhotoPriceDynamic: 'Single photo price {price}zł',
      error: 'An error occured while saving photo sales settings',
      success: 'Settings saved successfully',
      aboutPhotographerTitle: 'Photographer’s personalized page settings',
      aboutPhotographerInfo: 'Fill in these fields to personalize your public landing page.',
      landingHeadline: 'Welcome headline',
      landingBio: 'Short "About Me"',
      landingInstagram: 'Instagram link',
      openForBookings: 'Open for bookings?',
      acceptingBookings: 'Accepting bookings',
      notAcceptingBookings: 'Not accepting bookings',
      landingRegion: 'Where do you take bookings?',
      saveAndCreateLanding: 'Save and create my photographer page'
    }
  },
  status: {
    waiting: 'Waiting',
    rejected: 'Rejected',
    completed: 'Completed',
  },
  error: {
    badAuth: 'Bad authorization.',
    badAuthToken: 'Authorization error, please log in again.',
    badAuthPriviliges: 'Bad authorization - you need higher privileges.',
    badAuthTokenProblem: 'Bad authorization - problem with token.',
    route: 'No access.',
    walletNoAmmount: 'No amount or author or ballance fields',
    code: 'Something went wrong with code.',
    imageFail: 'Houston, we have got problem with upload image function',
    usernameRequired: 'Username field is required.',
    usernameExists: 'Username already exists.',
    emailRequired: 'Email field is required.',
    phoneNumber: 'Phone number field is required.',
    phoneNumberExists: 'Phone number already exists.',
    passwordRequired: 'Password field is required.',
    invalidCredentials: 'Invalid username or password.',
    emailExists: 'Email already exists, please try Reset Password.',
    addedImagesInfo: 'added images:',
    addedVideosInfo: 'added videos:',
    renewSendImages: 'Resume sending photos',
    renewSendVideos: 'Resume sending videos',
    sendLater: 'Close, i will send later',
    sendLaterInfo:
      'The photos from the first step have been updated, only those that have not been uploaded are left',
    catchedError: 'Error occured',
    registerWithdrawError: 'Withdraw registration error occured',
    errorBillingForm: 'Error while updating data, please check all fields.',
    fetchEvents: 'Something went wrong while fetching events. Please try again later.',
    noDashboardData: 'Not enough data to populate. Please try again later.',
    invalidEvent: 'This event does not exist or you do not have access to it.',
    eventUnverified: 'This event has not been verified by administrator.',
    uploadsRestriction: 'Due to high traffic we have enabled upload restrictions, only verified photographers can currently upload photos. Please check again later.',
    server: 'Invalid server response. Sorry, please try again, if unsuccessful, please come back in some time.',
    network: 'Sorry, there was a network problem, please try again later.',
    bookings: {
      invalidDate: 'Booking date must be in future.',
    },
    integration: 'An error occured during integration, please try agan later.',
    organizer: {
      photographer: {
        usernameExists: 'Username already exists.',
        emailExists: 'Email already exists.',
        portfolioInvalid: 'Portfolio URL is invalid.',
        generic: 'Error while registering photographer. Please try again.'
      }
    }
  },
  success: {
    registeredWithReq: 'A withdrawal request has been registered, thank you.',
    imageAdded: 'All, good. Images added, thank you!',
    videoAdded: 'All, good. Videos added, thank you!',
    accountHasBeenCreated: 'Account has been created successfully!',
    accountHasBeenCreatedPhotographerVerify:
      'Account has been created successfully! Type of your account is verifying.',
    billingDataUpdated: 'Billing data updated successfully!',
    integration: 'Integration successful',
    registerPhotographer: 'Photographer has been registered successfully!'
  },
  languages: {
    polish: 'Polish',
    english: 'English',
  },
  bookings: {
    today: "Today",
    myBookings: 'My bookings',
    goToPhotographers: 'Go to photographers',
    viewPhotographers: 'Verified photographers\' list',
    photographers: 'Photographer\'s',
    goToBookings: 'Go to bookings',
    loading: 'Loading bookings...',
    noActiveBookings: 'You do not have any active bookings.',
    bookingWith: 'Booking with:',
    bookingDate: 'Booking date',
    createdAt: 'Created at',
    region: 'Region',
    book: "Book",
    viewProfile: "View profile",
    statusLabel: 'Status',
    rateLabel: 'Rate',
    detailsMessage: 'Details / Message',
    noAdditionalMessage: 'No additional message.',
    loadError: 'Failed to load bookings.',
    photographersLoadError: 'Error loading list of photographers.',
    noPhotographersAvailable: 'No photographers are currently open for bookings.',
    status: {
      all: 'All',
      completed: 'Completed',
      pending: 'Pending',
      accepted: 'Accepted',
      rejected: 'Rejected',
      cancelled: 'Cancelled',
      unknown: 'Unknown'
    },
    store: {
      error: 'An error occured while sending a booking request.',
      success: 'Booking request sent!',
    },
    dialog: {
      cancel: {
        title: 'Confirm cancellation',
        message: 'Are you sure you want to cancel the booking with {name} on {date}?',
        action: 'Cancel',
        buttonYes: 'Cancel booking',
        buttonNo: 'Go back',
        success: 'The booking has been successfully cancelled.',
        error: 'An error occurred while cancelling the booking.',
      },
      accept: {
        title: 'Confirm acceptance',
        message: 'Are you sure you want to accept the booking from {name} for {date}?',
        action: 'Accept',
        buttonYes: 'Accept booking',
        buttonNo: 'Go back',
        success: 'The booking has been successfully accepted.',
        error: 'An error occurred while updating the booking status.',
      },
      reject: {
        title: 'Confirm rejection',
        message: 'Are you sure you want to reject the booking from {name} for {date}?',
        action: 'Reject',
        buttonYes: 'Reject booking',
        buttonNo: 'Go back',
        success: 'The booking has been successfully rejected.',
        error: 'An error occurred while rejecting the booking.',
      },
      complete: {
        title: 'Confirm completion',
        message: 'Are you sure you want to mark the booking as completed? We will transfer funds from your wallet onto photographer\'s account.',
        action: 'Mark as completed',
        buttonYes: 'Mark as completed and pay',
        buttonNo: 'Go back',
        success: 'The booking has been marked as completed.',
        error: 'An error occurred while marking the booking as completed.',
      }
    },
    fromOrganizer: 'Booking from:',
    goToCalendar: 'Go to Calendar',
    filterBy: "Filter status",
    currencySupportedLimitations: "Only PLN supported at this moment.",
    rateChangeHint: "The rate is fixed at the time of booking, if you'd like to change it, you can cancel the booking and create a new one.",
    available: 'Available',
    payout: {
      invalidStatus: 'Invalid status.',
      unathorized: 'Unauthorized',
      success: 'Booking has been paid for successfully.',
      wpError: 'An error occured in commission handling. Try again later or contact the admin.',
      error: 'An error occured, please try again later.',
      unexpected: 'Unexpected error, please try again later.'
    },
    eventsTitle: 'Events',
    bookingsTitle: 'Bookings',
    eventOrganizer: 'Organizer',
    insufficientFunds: 'Insufficient funds.'
  }
};
